import {Checkbox, Collapse, Flex, Input, Space} from "antd";
import {AIProvider, AIProviderSettings} from "../AIProvider";
import {} from "../../Prompt";
import {CommonSettings} from "../common/CommonSettings";

export const OpenAISettings = (props: {
    provider: AIProvider,
    settings: AIProviderSettings,
    onChange: (settings: AIProviderSettings) => void
}) => {

    return (
        <CommonSettings provider={props.provider} settings={props.settings} onChange={props.onChange}/>
    )
}